import { useTranslation } from 'react-i18next';
import { PageHeader } from 'components';
import styles from '../../extrasales/main/style.module.scss';
import Calendar from 'components/calendar';
import { usePromoCalendar } from '../usePromoCalendar';

const PromoCalendar = () => {
  const { t } = useTranslation();
  const { data } = usePromoCalendar();

  return (
    <>
      <PageHeader title={t('Calendario prenotazioni').toUpperCase()} />
      <div className={styles.container}>
        <Calendar data={data.extrasales} />
      </div>
    </>
  );
};

export default PromoCalendar;
